import React, { useEffect } from "react";
import Header from "../../../components/User/Header/Header";
import Footer from "../../../components/User/Footer/Footer";

function ExtraBaggageCost() {

   useEffect(()=>{
  window.scrollTo(0,0)
    },[])

  return (
    <div className="page-wrapper">
      <Header/>
      {/* Hero Section  */}
      <section
        class="call-to-action-one sp-four"
        //   style={{ backgroundImage: `url(${HomeBanner})` }}
      >
        <div class="container">
          <div class="sec-title-one white text-center">
            <h2>Minimize Your Extra Baggage Cost</h2>
          </div>
        </div>
      </section>
      <section className="why-chooseus sp-four">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="sec-title-one">
                  {/* <h5>Our Qualification</h5> */}
                  <h2>
                    <span>Extra Baggage Cost </span>
                    <br />
                  </h2>
                </div>
                <div className="text mt-45">
                  <p>
                    If you are a student traveling to abroad for your education
                    or just any other person simply relocating to a foreign land
                    then, you are bound to have a lot of luggage and if you are
                    couriering it then it might happen that you have to be there
                    at the customs office to collect your stuff in person. This
                    is because the country’s system does not allow someone else
                    to do the same for you. This is where you can be at a
                    benefit by booking baggage delivery to airport service from
                    CarryMyBaggage.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-right-area">
                <figure>
                  <img
                    src={require("../../../images/resource/shoose-us-1.jpg")}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="text mt-45">
                  <p>
                    CarryMyBaggage is a travel friendly service provider that
                    offers to deliver your luggage from your door to airport so
                    that you do not have to waste time at the customs line to
                    clear your luggage after your arrival as in some countries
                    the rules require the owner of the baggage to be present for
                    the clearance and sometimes you have to pay extra for
                    delivery to your home. But if you take the help of
                    CarryMyBaggage, they would pick up your luggage from your
                    home in India and deliver it to the destination airport
                    clear the custom for you and send you the required documents
                    so that you can collect your baggage from the custom
                    warehouse. We are the pioneers of this service in India and
                    we also have a enthusiastic team of employees who uptakes
                    the responsibility of safely delivering your luggage to the
                    desired location airport.
                  </p>
                  <p>
                    Our door to airport baggage service is a part of our other
                    unique services which helps you in making your travel easier
                    than it was ever before. This service is beneficial for
                    students who are traveling abroad for higher education,
                    working people relocating and even for families going for a
                    big fat destination wedding.
                  </p>
                  <p>
                    Don’t you think this is one of the best services that any
                    digital day travel plan could have provided you with? Well,
                    the best thing about CarryMyBaggage services is that
                    everything can be done online, be it booking the service or
                    tracking your baggage. Technology has no doubt made
                    travelling easy but CarryMyBaggage makes carrying your
                    luggage from one destination to the other easy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default ExtraBaggageCost;
